import { styled } from 'styled-components';
import InputComponent from '../../components/utils/Input/Input';

export const ModalButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: '100%';
  padding-top: 30px;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const ButtonModalSubscribe = styled.button`
  border-radius: 16px;
  border: 1px solid #262626;
  display: flex;
  width: 100%;
  height: 54px;
  padding: 16px 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: #262626;
  cursor: pointer;
  color: #fffdfc;
  text-align: justify;

  font-size: 16px;
  font-family: 'Poppins-Medium';
  font-style: normal;
  line-height: 22px; /* 137.5% */
  letter-spacing: -0.408px;

  &:active {
    transition: all 0.2s ease-in-out;
    scale: 0.95;
  }
`;

export const ModalTitle = styled.span`
  color: #000;
  text-align: justify;
  font-family: 'Playfair Display';
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 39px; /* 162.5% */
`;

export const Gap = styled.div`
  margin-bottom: 24px;
`;

export const ModalSubtitle = styled.span`
  font-size: 16px;
  font-style: normal;
  font-family: 'Poppins-Medium';

  line-height: normal;
  letter-spacing: -0.408px;
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: calc(100% - 60px);
`;

export const ButtonModal = styled(ButtonModalSubscribe)`
  background: '#000';
  border: none;
`;

export const PriceText = styled.span`
  font-family: 'Poppins-SemiBold';

  font-size: 24px;

  letter-spacing: -0.408px;
`;

export const PriceRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;
  align-items: center;
  padding-top: 24px;
  padding-bottom: 24px;
`;

export const PriceTextGray = styled.span`
  font-family: 'Poppins-Regular';

  font-size: 18px;

  letter-spacing: -0.408px;
  opacity: 0.4;
`;

export const ButtonModalLater = styled.button`
  display: flex;
  //width: 100%;
  border: 0px;
  // height: 54px;
  background-color: transparent;
  padding: 16px 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  color: #1e1e1e;
  text-align: justify;

  font-size: 16px;
  font-style: normal;
  font-family: 'Poppins-Medium';

  line-height: 22px; /* 137.5% */
  letter-spacing: -0.408px;

  &:active {
    transition: all 0.2s ease-in-out;
    scale: 0.95;
  }
`;

export const StyledInput = styled(InputComponent)`
  width: 100%;
`;
